/* Bron-selector voor de multi-source Talent Search.
 * Haalt GET /talent/search/sources op en rendert een chip per bron:
 *  - geconfigureerd  → toggle aan/uit (aan = wordt doorzocht)
 *  - niet geconfigureerd → disabled, "geen key" + link naar Integraties
 */
import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { Link } from "react-router-dom";
import { Check, KeyRound, Database, Linkedin, Globe } from "lucide-react";
import { api } from "@/lib/api";

export const SOURCE_META = {
    apollo:          { Icon: Database, tint: "#f59e0b" },
    linkedin_serper: { Icon: Linkedin, tint: "#0a66c2" },
    linkedin_apify:  { Icon: Linkedin, tint: "#4d9be6" },
    perplexity:      { Icon: Globe,    tint: "#22d3ee" },
};

// sourced_by (Candidate) → korte bronvermelding op kaart/tabel
export const SOURCED_BY_LABEL = {
    apollo_talent_search: "Apollo",
    serper_linkedin_search: "LinkedIn X-ray",
    apify_linkedin_search: "LinkedIn (Apify)",
    perplexity_talent_search: "Perplexity",
};

export function SourceSelector({ selected, onToggle, onInit }) {
    const [sources, setSources] = useState(null);
    useEffect(() => {
        api.get("/talent/search/sources")
            .then((r) => {
                setSources(r.data || []);
                onInit?.((r.data || []).filter((s) => s.configured).map((s) => s.id));
            })
            .catch(() => setSources([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (sources === null) return null;

    return (
        <div className="mt-3" data-testid="source-selector">
            <label className="text-[10px] font-mono uppercase tracking-[0.18em] text-[var(--jr-text-3)]">
                {i18n.t("search.sources_label")}
            </label>
            <div className="mt-1.5 flex flex-wrap gap-1.5">
                {sources.map((s) => {
                    const meta = SOURCE_META[s.id] || SOURCE_META.apollo;
                    const Icon = meta.Icon;
                    if (!s.configured) {
                        return (
                            <Link key={s.id} to="/app/integrations"
                                data-testid={`source-${s.id}`}
                                title={i18n.t("search.source_no_key_tip", { source: s.label })}
                                className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border border-dashed border-white/15 text-[var(--jr-text-3)] opacity-70 hover:opacity-100 hover:text-[var(--jr-amber)]">
                                <KeyRound size={10} /> {s.label} · {i18n.t("search.source_no_key")}
                            </Link>
                        );
                    }
                    const on = selected.includes(s.id);
                    return (
                        <button key={s.id} type="button" onClick={() => onToggle(s.id)}
                            data-testid={`source-${s.id}`}
                            className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border transition-colors ${on
                                ? "border-transparent text-black font-medium"
                                : "border-white/10 text-[var(--jr-text-2)] hover:bg-white/5"}`}
                            style={on ? { background: meta.tint } : {}}>
                            {on ? <Check size={10} /> : <Icon size={10} style={{ color: meta.tint }} />}
                            {s.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
